import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { pxToRem, color } from '../../utils'
import { NavLink } from 'react-router-dom'
import { PlaceholderMenu } from '../loaders'
import closeIcon from '../../assets/icons/close-light.png'

const Wrapper = styled.div`
  background: #fff;
  width: ${pxToRem('217px')};
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  align-self: stretch;
  min-height: calc(100% - ${pxToRem(104)});
  z-index: 1;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  transform: translateX(-100%);
  visibility: hidden;
  transition: 0.2s;
  overflow-y: auto;

  ${({ open }) =>
    open
      ? `
    transform: translateX(0);
    visibility: visible;
  `
      : ''} ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  nav {
    width: 100%;
    position: relative;
  }
`

const Backdrop = styled.a`
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  transition: 0.2s;
  visibility: hidden;
  cursor: pointer;
  ${({ open }) =>
    open
      ? `
    opacity: 1;
    visibility: visible;
  `
      : ''} &::before {
    content: url(${closeIcon});
    position: absolute;
    right: ${pxToRem(15)};
    top: ${pxToRem(15)};
  }
`

const Item = styled.li`
  padding-left: 30px;
`

const MenuLink = styled(NavLink)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  text-decoration: none;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(14)};
  padding: ${pxToRem(37)} 0 ${pxToRem(37)} 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #9facb5;
  border-bottom: 1px solid #d8d8d8;
  > span {
    flex: 1;
    align-self: center;
    padding-right: ${pxToRem(10)};
  }
  &.menu-link-active {
    color: ${color.secondary};
    display: flex;
    &::after {
      content: '';
      display: block;
      width: ${pxToRem(10)};
      height: ${pxToRem(10)};
      border-radius: 50%;
      background-color: ${color.secondary};
      box-shadow: 0 0 10px 0 ${color.secondary};
    }
  }
`

const MenuLinkLabel = MenuLink.withComponent('label')

const MenuLinkWithSub = styled(MenuLinkLabel)`
  ${({ active }) =>
    active
      ? `
    color: ${color.secondary};
    display: flex;
    &::after {
      content: '';
      transform: translate(${pxToRem('5px')});
      display: block;
      width: ${pxToRem(10)};
      height: ${pxToRem(10)};
      border-radius: 50%;
      background-color: ${color.secondary};
      box-shadow: 0 0 10px 0 ${color.secondary};
    }
  `
      : ''} cursor: pointer;
`

const SubMenu = styled.ul`
  margin-top: -1px;
  ${Item} {
    margin-left: -30px;
    background: #d8d8d84c;
  }
`

const SubMenuLink = styled(NavLink)`
  display: inline-block;
  box-sizing: border-box;
  text-decoration: none;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(12)};
  padding: ${pxToRem(29)} ${pxToRem(29)} ${pxToRem(29)} 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #9facb5;
  border-bottom: 1px solid #d8d8d8;
  &.menu-link-active {
    color: ${color.secondary};
    position: relative;
  }
`

const ItemWithSubMenu = styled(Item)`
  input[type='checkbox'] {
    display: none;
  }
  ${SubMenu} {
    visibility: hidden;
    height: 0;
    width: 0;
    opacity: 0;
    transform: scaleY(0.8);
    transition: opacity 0.2s, transform 0.2s;
  }
  input[type='checkbox']:checked {
    & ~ ${SubMenu} {
      visibility: visible;
      height: auto;
      width: auto;
      opacity: 1;
      transform: scaleY(1);
      transform-origin: top;
    }
    & ~ ${MenuLinkWithSub} {
      border-bottom: none;
      color: ${color.secondary};
    }
  }
`

const UserInfos = styled.div`
  color: #5b666d;
  font-weight: bold;
  padding: ${pxToRem(28)} ${pxToRem(30)} ${pxToRem(30)};
  background: #f5f5f5;
  font-size: ${pxToRem(14)};
  border-bottom: 1px solid #d8d8d8;

  span {
    color: ${color.secondary};
    margin-top: ${pxToRem(7)}
  }
`

const ChangeArea = styled.button`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  text-decoration: none;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(14)};
  padding: ${pxToRem(15)} 0 ${pxToRem(15)} ${pxToRem(30)};
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  border: none;
  background-color: ${color.secondary};
`

class MenuMobile extends Component {
  render() {
    const {
      menuItems = [],
      fetchingMenu,
      router,
      open,
      closeMenu,
      openAreaModal,
      userName = 'usuário',
      areaName = 'Área indefinida',
      canChangeArea = false
    } = this.props

    return (
      <Fragment>
        <Backdrop open={open} onClick={closeMenu} />
        <Wrapper open={open}>
          <UserInfos>
            <strong>Olá, {userName}</strong>
            <br />
            <span>{areaName}</span>
          </UserInfos>

          <ChangeArea
            onClick={() => {
              openAreaModal()
            }}
          >
            Trocar área
          </ChangeArea>

          <nav>
            {fetchingMenu ? (
              <PlaceholderMenu />
            ) : (
              <ul>
                {menuItems.map(item => {
                  return item.subMenu ? (
                    <ItemWithSubMenu key={item.id}>
                      {!!router.location.pathname.includes(item.id) ? (
                        <input id={`sub-menu-mobile-${item.id}`} type="checkbox" defaultChecked />
                      ) : (
                        <input id={`sub-menu-mobile-${item.id}`} type="checkbox" />
                      )}
                      <MenuLinkWithSub
                        active={((router.location || {}).pathname || '').includes(item.id)}
                        htmlFor={`sub-menu-mobile-${item.id}`}
                      >
                        <span>{item.name}</span>
                      </MenuLinkWithSub>
                      <SubMenu>
                        {item.subMenu.map(subItem => (
                          <Item key={subItem.id}>
                            <SubMenuLink to={`/${subItem.id}`} activeClassName={'menu-link-active'}>
                              {subItem.name}
                            </SubMenuLink>
                          </Item>
                        ))}
                      </SubMenu>
                    </ItemWithSubMenu>
                  ) : (
                    <Item key={item.id}>
                      <MenuLink to={`/${item.id}`} activeClassName={'menu-link-active'}>
                        <span>{item.name}</span>
                      </MenuLink>
                    </Item>
                  )
                })}
              </ul>
            )}
          </nav>
        </Wrapper>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    menuItems: state.menu.items,
    fetchingMenu: state.menu['is_fetching']
  }
}

const mapDispatchToProps = state => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MenuMobile)



// WEBPACK FOOTER //
// ./src/components/Header/MenuMobile.js